import React from 'react'

interface TableaPginationProps {
  currentPage: number
  pageCount: number
  onPageChange: (selected: number) => void
}

const PAGE_RANGE_DISPLAYED = 5

export const TablePagination: React.FC<TableaPginationProps> = (props) => {
  const { currentPage, pageCount, onPageChange } = props

  const getPageRange = () => {
    const halfRange = Math.floor(PAGE_RANGE_DISPLAYED / 2)
    let start = Math.max(0, currentPage - halfRange)
    let end = Math.min(pageCount - 1, start + PAGE_RANGE_DISPLAYED - 1)

    if (end - start + 1 < PAGE_RANGE_DISPLAYED && start > 0) {
      start = Math.max(0, end - PAGE_RANGE_DISPLAYED + 1)
    }

    const pages = []
    for (let i = start; i <= end; i++) {
      pages.push(i)
    }

    return { start, end, pages }
  }

  const { start, end, pages } = getPageRange()

  const handlePageClick = (page: number) => {
    if (page >= 0 && page < pageCount && page !== currentPage) {
      onPageChange(page)
    }
  }

  return (
    <div className='pagination-pagination'>
      <button
        className={`item-pagination ki-duotone ki-left fs-2x ${
          currentPage === 0 ? 'disabled-page-pagination' : ''
        }`}
        onClick={() => handlePageClick(currentPage - 1)}
        disabled={currentPage === 0}
      >
        <span />
      </button>

      {start > 0 && (
        <>
          <button
            className={`item-pagination pagination-page-pagination ${
              currentPage === 0 ? 'active-pagination' : ''
            }`}
            onClick={() => handlePageClick(0)}
          >
            1
          </button>
          {start > 1 && <span className='item-pagination break-me-pagination'>...</span>}
        </>
      )}

      {pages.map((page) => (
        <button
          key={page}
          className={`item-pagination pagination-page-pagination ${
            currentPage === page ? 'active-pagination' : ''
          }`}
          onClick={() => handlePageClick(page)}
        >
          {page + 1}
        </button>
      ))}

      {end < pageCount - 1 && (
        <>
          {end < pageCount - 2 && <span className='item-pagination break-me-pagination'>...</span>}
          <button
            className={`item-pagination pagination-page-pagination ${
              currentPage === pageCount - 1 ? 'active-pagination' : ''
            }`}
            onClick={() => handlePageClick(pageCount - 1)}
          >
            {pageCount}
          </button>
        </>
      )}

      <button
        className={`item-pagination ki-duotone ki-right fs-2x ${
          currentPage === pageCount - 1 ? 'disabled-page-pagination' : ''
        }`}
        onClick={() => handlePageClick(currentPage + 1)}
        disabled={currentPage === pageCount - 1}
      >
        <span />
      </button>
    </div>
  )
}
